(function() {
  function initImpactoModular(root) {
    if (!root || root.dataset.impactoModularInitialized === 'true') return;

    root.dataset.impactoModularInitialized = 'true';

    var counters = Array.prototype.slice.call(root.querySelectorAll('[data-im-counter]'));

    if (!counters.length) return;

    var hasAnimated = false;

    function animateCounter(counter) {
      var target = parseInt(counter.getAttribute('data-target') || '0', 10);

      if (isNaN(target)) {
        target = 0;
      }

      if (target === 0) {
        counter.textContent = '0';
        return;
      }

      var duration = 1100;
      var startTime = null;

      function step(timestamp) {
        if (!startTime) {
          startTime = timestamp;
        }

        var progress = Math.min((timestamp - startTime) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = Math.round(target * eased);

        counter.textContent = value;

        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          counter.textContent = target;
        }
      }

      window.requestAnimationFrame(step);
    }

    function runCounters() {
      if (hasAnimated) return;

      hasAnimated = true;

      counters.forEach(function(counter) {
        animateCounter(counter);
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            runCounters();
            observer.disconnect();
          }
        });
      }, {
        threshold: 0.35
      });

      observer.observe(root);
    } else {
      runCounters();
    }
  }

  function initAllImpactoModular() {
    var roots = document.querySelectorAll('.js-impacto-modular');

    roots.forEach(function(root) {
      initImpactoModular(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllImpactoModular);
  } else {
    initAllImpactoModular();
  }

  document.addEventListener('shopify:section:load', function(event) {
    var root = event.target.querySelector('.js-impacto-modular');

    if (root) {
      root.dataset.impactoModularInitialized = 'false';
      initImpactoModular(root);
    }
  });
})();